import React from 'react';
import getDisplayField from './Display';
import getEditField from './Edit';

// Override components in parent project
const ctx = {
  getDisplayField,
  getEditField
};

export default React.createContext(ctx);